import { isEmpty } from 'lodash';
import React, { Fragment, useState } from 'react';
import { useTranslation } from 'react-i18next';

import { Button } from 'components';
import {
  IMAGE_ICON_PATH,
  TELEGRAM_ICON_PATH,
} from 'constants/images.constants';
import { useOrderContext } from 'hooks';
import { TranslationNamespace } from 'i18n';
import { DefaultUploadReceiptDialog } from 'views/DefaultOrderView/components/DefaultUploadReceiptDialog';

export const DefaultPaymentReceiptsDispute: React.FC = () => {
  const { t } = useTranslation(TranslationNamespace.Common, {
    keyPrefix: 'components.payment_receipts_dispute',
  });

  const {
    refetchOrder,
    receiptsResult: {
      receipts,
      uppy,
      setReceiptUploadCallbacks,
      telegramSupportBotUrl,
      handleTelegramOrderHelp,
      handleTelegramUploadReceipt,
    },
  } = useOrderContext();

  const [uploadModalOpen, setUploadModalOpen] = useState(false);

  return (
    <div className="tw-flex tw-flex-col tw-items-center">
      {isEmpty(receipts) ? (
        <Fragment>
          <div className="tw-text-primary tw-text-md tw-font-bold tw-text-center md:tw-text-lg">
            {t('no_receipts.title')}
          </div>

          <div className="tw-text-primary tw-text-md tw-text-center tw-mb-6 md:tw-mb-8 md:tw-text-lg">
            {t('no_receipts.description')}
          </div>

          <Button
            className="tw-max-w-md tw-max-h-16 tw-mb-4"
            iconPath={IMAGE_ICON_PATH}
            color="primary"
            onClick={() => {
              setReceiptUploadCallbacks(refetchOrder, () =>
                setUploadModalOpen(false),
              );
              setUploadModalOpen(true);
            }}
          >
            {t('buttons.upload')}
          </Button>
          {!!telegramSupportBotUrl && (
            <span
              className="tw-text-secondary tw-text-l tw-underline tw-text-center tw-cursor-pointer"
              onClick={handleTelegramUploadReceipt}
            >
              {t('buttons.upload_by_telegram')}
            </span>
          )}
        </Fragment>
      ) : (
        <Fragment>
          <div className="tw-text-primary tw-text-md tw-font-bold tw-text-center tw-mb-8 md:tw-text-lg">
            {t('receipts_uploaded.title')}
          </div>

          {!!telegramSupportBotUrl && (
            <Fragment>
              <div className="tw-text-primary tw-text-md tw-text-center tw-mb-6 md:tw-mb-8 md:tw-text-lg">
                {t('receipts_uploaded.description')}
              </div>
              <Button
                className="tw-max-w-xs tw-max-h-16"
                iconPath={TELEGRAM_ICON_PATH}
                iconClassName="md:tw-w-9"
                color="info"
                onClick={handleTelegramOrderHelp}
              >
                {t('buttons.support')}
              </Button>
            </Fragment>
          )}
        </Fragment>
      )}

      {/* Mounting the dialog loads the receipt uploader (SPAY-5216), so only while the upload button is shown.
          An open dialog stays mounted until it closes, even when the upload has just added a receipt. */}
      {(isEmpty(receipts) || uploadModalOpen) && (
        <DefaultUploadReceiptDialog
          open={uploadModalOpen}
          uppy={uppy}
          onClose={() => setUploadModalOpen(false)}
        />
      )}
    </div>
  );
};
